import { makeStyles } from "@material-ui/styles";
import { Color } from "../../theme/color";
import { Box, Button, Typography } from "@material-ui/core";

type Props = {
  disabled?: boolean;
  enabledValue?: string;
  disabledValue?: string;
  value: boolean;
  setValue: (value: boolean) => void;
  enabledTranslate?: string;
  disabledTranslate?: string;
  enabledScaleSize?: number;
  disabledScaleSize?: number;
};

/**
 * @deprecated mad props, use ButtonGroup
 */
export function Toggle(props: Props) {
  const classes = useStyles();

  return (
    <Box sx={{ display: "flex" }}>
      <Box className={classes.maskBox}>
        <Box
          className={classes.mask}
          style={{
            transform: `translateX(${
              !props.value
                ? props.disabledTranslate ?? 0
                : props.enabledTranslate ?? "7.1rem"
            }) scaleX(${
              !props.value ? props.disabledScaleSize ?? 1 : props.enabledScaleSize ?? 0.85
            })`
          }}
        />
        <Button
          className={classes.button}
          style={{
            borderRadius: "6px 0px 0px 6px"
          }}
          disableRipple
          variant="text"
          onClick={() => props.setValue(false)}
        >
          <Typography
            color={props.value ? "textSecondary" : "inherit"}
            style={props.value ? { color: Color.Gray } : {}}
            variant="h5"
          >
            {props.disabledValue}
          </Typography>
        </Button>
        <Button
          className={classes.button}
          style={{
            borderRadius: "0px 6px 6px 0px"
          }}
          disableRipple
          variant="text"
          onClick={() => props.setValue(true)}
        >
          <Typography
            style={!props.value ? { color: Color.Gray } : {}}
            color={props.value ? "inherit" : "textSecondary"}
            variant="h5"
          >
            {props.enabledValue}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles(() => ({
  maskBox: {
    borderRadius: "6px",
    position: "relative",
    opacity: 1,
    backgroundColor: Color.LightGray,
    color: Color.White
  },
  mask: {
    width: "7.8rem",
    height: "2.5rem",
    borderRadius: "6px",
    background: Color.PrimaryMain,
    position: "absolute",
    opacity: 1,
    transition: "all 0.5s ease"
  },
  button: {
    height: "2.5rem",
    borderRadius: "6px",
    color: Color.White,
    padding: "12px",
    boxShadow: "0px 8px 24px 0px rgba(128, 128, 128, 0.15)",
    opacity: 1,
    backgroundColor: "transparent",
    "&:hover": {
      opacity: 1,
      backgroundColor: "transparent"
    }
  }
}));
